import { queryKeyFn } from '../../generated/sitContext';
export const getTimesheetEntriesQueryKey = (timesheetId, includeAllocationChildren) => queryKeyFn({
    path: '/timesheets/{id}/entries',
    operationId: 'getApiTimesheetsByUuidEntries',
    variables: {
        pathParams: {
            id: timesheetId,
        },
        queryParams: includeAllocationChildren !== undefined
            ? { includeAllocationChildren }
            : {},
    },
});
export const getTimesheetEntryQueryKey = (timesheetId, entryId) => queryKeyFn({
    path: '/timesheets/{id}/entries/{entryId}',
    operationId: 'getApiTimesheetsEntryById',
    variables: {
        pathParams: {
            id: timesheetId,
            entryId,
        },
    },
});
//# sourceMappingURL=query-key.js.map